/* ── VULGAR:ERRORS — PDP: trust row + sticky add-to-cart ──
   Injected, so main-product.liquid stays stock. A trust row drops in after the
   buy buttons; a sticky bottom bar appears once the real add-to-cart scrolls
   off-screen and proxies its click (biggest lift on mobile). PDP-only: the
   whole module bails if there is no buy button on the page. */
(function () {
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var buyBtns = document.querySelector('.product-form__buttons');
    var atc = document.querySelector('.product-form__submit');
    if (!buyBtns || !atc) return; // not a product page

    var css = document.createElement('style');
    css.textContent = [
      /* trust row — inherits the PDP text colour (light on the dark product page) */
      '.ve-trust{display:grid;grid-template-columns:1fr 1fr;gap:13px 22px;margin:26px 0 4px;padding-top:22px;border-top:1px solid rgba(128,128,128,.28);}',
      '.ve-trust__i{display:flex;align-items:center;gap:10px;font-size:10.5px;letter-spacing:.15em;text-transform:uppercase;color:inherit;opacity:.86;line-height:1.3;}',
      '.ve-trust__i svg{flex:0 0 auto;width:17px;height:17px;stroke:currentColor;fill:none;stroke-width:1.4;stroke-linecap:round;stroke-linejoin:round;opacity:.9;}',
      /* sticky add-to-cart bar */
      '.ve-sticky{position:fixed;left:0;right:0;bottom:0;z-index:40;background:#fff;color:#000;border-top:1px solid rgba(0,0,0,.1);box-shadow:0 -6px 26px rgba(0,0,0,.16);transform:translateY(115%);transition:transform .42s cubic-bezier(.16,1,.3,1);display:flex;align-items:center;gap:16px;padding:11px 20px calc(11px + env(safe-area-inset-bottom));}',
      '.ve-sticky.is-on{transform:translateY(0);}',
      '.ve-sticky__img{width:44px;height:44px;object-fit:cover;flex:0 0 auto;background:#111;display:block;}',
      '.ve-sticky__meta{display:flex;flex-direction:column;min-width:0;flex:1;gap:2px;}',
      '.ve-sticky__t{font-size:12px;font-weight:700;letter-spacing:.11em;text-transform:uppercase;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
      '.ve-sticky__p{font-size:12.5px;opacity:.68;}',
      '.ve-sticky__btn{flex:0 0 auto;appearance:none;border:0;background:#000;color:#fff;font:inherit;font-size:11px;font-weight:700;letter-spacing:.22em;text-transform:uppercase;padding:15px 32px;cursor:pointer;transition:opacity .2s,letter-spacing .3s;}',
      '.ve-sticky__btn:hover{opacity:.85;letter-spacing:.3em;}',
      '@media(min-width:750px){.ve-sticky{padding-left:44px;padding-right:44px;}.ve-sticky__btn{padding:16px 46px;}}',
      '@media(max-width:749px){.ve-sticky{padding-right:78px;}}' /* leave room for chat bubble */
    ].join('');
    document.head.appendChild(css);

    if (!document.querySelector('.ve-trust')) {
      var I = {
        made: '<svg viewBox="0 0 24 24"><path d="M21 8l-9-5-9 5 9 5 9-5zM3 8v8l9 5 9-5V8"/></svg>',
        print: '<svg viewBox="0 0 24 24"><path d="M6 9V3h12v6"/><path d="M6 17H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2"/><rect x="6" y="13" width="12" height="8"/></svg>',
        globe: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3c2.6 2.6 2.6 15.4 0 18M12 3c-2.6 2.6-2.6 15.4 0 18"/></svg>',
        lock: '<svg viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="9" rx="1"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>'
      };
      function item(svg, t) { return '<span class="ve-trust__i">' + svg + '<span>' + t + '</span></span>'; }
      var row = document.createElement('div');
      row.className = 've-trust';
      row.innerHTML = item(I.made, 'Made to order') + item(I.print, 'Printed in the USA') + item(I.globe, 'Ships worldwide') + item(I.lock, 'Secure checkout');
      buyBtns.insertAdjacentElement('afterend', row);
    }

    var titleEl = document.querySelector('.product__title h1');
    var bar = document.createElement('div');
    bar.className = 've-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<img class="ve-sticky__img" alt="" hidden><span class="ve-sticky__meta"><span class="ve-sticky__t"></span><span class="ve-sticky__p"></span></span><button type="button" class="ve-sticky__btn">Add to cart</button>';
    document.body.appendChild(bar);
    if (titleEl) bar.querySelector('.ve-sticky__t').textContent = titleEl.textContent.trim();
    var pImg = document.querySelector('.product__media-wrapper img, .product-media img, [id^="Slider-Gallery"] img, .product__media img');
    var thumb = bar.querySelector('.ve-sticky__img');
    var pSrc = pImg && (pImg.currentSrc || pImg.src);
    if (pSrc) { thumb.src = pSrc; thumb.hidden = false; }

    function syncPrice() {
      var p = document.querySelector('.price--on-sale .price-item--sale') || document.querySelector('.price__container .price-item--regular');
      if (p) bar.querySelector('.ve-sticky__p').textContent = p.textContent.trim();
    }
    function syncBtn() {
      var real = document.querySelector('.product-form__submit');
      var b = bar.querySelector('.ve-sticky__btn');
      if (!real) return;
      var dis = real.hasAttribute('disabled');
      b.textContent = dis ? 'Sold out' : 'Add to cart';
      b.style.opacity = dis ? '.5' : '';
      b.style.pointerEvents = dis ? 'none' : '';
    }
    syncPrice(); syncBtn();

    bar.querySelector('.ve-sticky__btn').addEventListener('click', function () {
      var real = document.querySelector('.product-form__submit');
      if (real && !real.hasAttribute('disabled')) real.click();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(atc);
    }

    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects, .product-form__input')) {
        setTimeout(function () { syncPrice(); syncBtn(); }, 450);
      }
    });
  });
})();

/* ── VULGAR:ERRORS — PDP: GPSR row + size-chart tidy ── */
(function () {
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  var GPSR_URL = '/pages/faq-returns';

  ready(function () {
    /* 1. GPSR / product-safety row — stays an in-place dropdown.
       The theme renders it as a collapsible_tab whose `content` is empty and
       whose `page` setting holds unevaluated Liquid, so it opened onto
       nothing. The copy now lives in the block's `content` setting
       (templates/product.json) and simply drops down here — deliberately NOT
       a redirect: sending a shopper off the product page to read compliance
       text loses the sale. */
    document.querySelectorAll('.product__accordion').forEach(function (acc) {
      var summary = acc.querySelector('summary');
      if (!summary) return;
      if (!/GPSR|product safety/i.test(summary.textContent || '')) return;
      acc.classList.add('ve-gpsr');
    });

    /* 2. Size-chart tooltip (Pify app).
       Its panel was 6px shorter than its own content with overflow-y:auto, so
       the final measurement row sat clipped behind a scrollbar — the "half
       showing" chart. Letting it size to its content fixes it without touching
       the app. The hover dimensions themselves are kept; only the clipping is
       removed. The inline "Size Chart" launcher is also given a real tap
       target (it rendered 16px tall). */
    var css = document.createElement('style');
    css.textContent = [
      '.pify_size_tooltip{height:auto !important;max-height:none !important;overflow:visible !important;}',
      '.pify_tooltip_table{margin:0 !important;}',
      '.pify_inline_button,.pify-overlay-button{min-height:44px !important;display:inline-flex !important;align-items:center;gap:.6rem;margin-top:0 !important;}',
      '.ve-gpsr summary{cursor:pointer;}',
      /* Close the dead space between the size selector and the Size Chart
         link. Three margins stacked up to ~33px of nothing: variant-selects
         (15px bottom), product-form (25px top) and the app button's own 8px.
         The chart link belongs visually attached to the sizes it explains. */
      '.product__info-container variant-selects{margin-bottom:4px !important;}',
      '.product__info-container product-form,.product__info-wrapper product-form{margin-top:6px !important;}'
    ].join('');
    document.head.appendChild(css);

    /* 3. Nothing but the hover tooltip and the "Size Chart" launcher may sit
       in the buy column. Some products have the app's inline chart enabled,
       which stacks a full measurement table directly under the size pills —
       it pushes the add-to-cart button down the page and reads as clutter.
       The full table belongs behind the launcher.

       Swept in JS rather than by CSS class name because the app's inline
       markup varies; anything containing a <table> that is neither the
       tooltip nor the launcher gets removed from the buy column. */
    function sweepInlineCharts() {
      var col = document.querySelector('.product__info-container, .product__info-wrapper');
      if (!col) return;
      col.querySelectorAll('table').forEach(function (t) {
        if (t.closest('.pify_size_tooltip')) return;      // hover detail — keep
        if (t.closest('.product__accordion')) return;     // author's own content — keep
        if (t.closest('.ve-qa-sheet')) return;
        var host = t.closest('[class*="pify"]') || t;
        host.style.display = 'none';
      });
    }
    sweepInlineCharts();
    // The app injects late and re-renders on variant change.
    var tries = 0;
    var poll = setInterval(function () {
      sweepInlineCharts();
      if (++tries > 12) clearInterval(poll);
    }, 400);
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects, .product-form__input')) {
        setTimeout(sweepInlineCharts, 450);
      }
    });
  });
})();
